function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}


function updateFreeShippingMessage(cartTotalPrice) {
  const threshold = 65;
  const progressEl = document.querySelector('.progress-bar__progress');
  const messageRegular = document.querySelector('.progress-message');
  const messageSuccess = document.querySelector('.progress-message--success');
  const amountUntilFreeShipping = document.getElementById('amountFreeShipping');

  if(!progressEl || !messageRegular || !messageSuccess || !amountUntilFreeShipping) return;
  amountUntilFreeShipping.innerHTML = threshold - cartTotalPrice;
  let progress = (cartTotalPrice / threshold).toFixed(2) * 100 - 20;
  if(cartTotalPrice == 0) progress = 5;
  else if(progress < 10) progress = 10;
 
  if(threshold - cartTotalPrice <= 0) {
    messageRegular.classList.add('hidden');
    messageSuccess.classList.remove('hidden');
    progressEl.style.width = '100%';
  }
  else {
    messageRegular.classList.remove('hidden');
    messageSuccess.classList.add('hidden');
    progressEl.style.width = String(progress) + '%';
  }
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.previousValue = 0;
    this.input = this.querySelector('input') || this.querySelector('.quantity__input');
    this.minusButton = this.querySelector("button[name='minus']");
    this.changeEvent = new Event('change', { bubbles: true });
    this.handleMinusButton();

    /*
      If this instance is not registered, find the quantit-input button and register the reference.
    */
    if (!this.input) {
      this.input = document.querySelector("quantity-input input")
      return
    }
    // else {
    this.input.addEventListener("change", (e) => {
      this.handleMinusButton();
      const variant_id = e.target.dataset.id;
      if (!((window.customer || {}).tags || "").includes('Appstle_Subscriber')) {
        const addOn = document.querySelector(`addon-overlay input[data-id='${variant_id}']`);
        if (addOn && addOn.checked) {
          var quantity = addOn.dataset.quantity;
          var p_q = this.previousValue;
          this.getCart().then(res => {
            var previous_quantity = 0
            res.items.forEach(item => {
              if (item.id == addOn.dataset.variant) {
                previous_quantity += item.quantity;
              }
            });
            if (p_q > (this.input.value * 1)) {
              quantity = previous_quantity - (quantity * 1)
            } else {
              quantity = previous_quantity + (quantity * 1)
            }
            if (quantity < 0)
              quantity = 0;
            var update = {};
            update[variant_id] = addOn.dataset.single_bundle ? 0 : this.input.value;
            update[addOn.dataset.variant] = quantity;
            this.updateQuantityMultiple(update).then(res => {
              if ((this.input.value * 1) <= 0) {
                addOn.checked = false;
                removeVariantId(variant_id)
              }
              this.handleSingle(addOn.dataset.single_bundle, variant_id, this.input.value * 1, addOn.dataset.variant)
              updateCartBubbles(res);
              updateCartProgress(res);
              updateFreeShippingMessage(res.total_price / 100);
            })
          })

        }
        else {
          const cartUpdateaa = this.updateQuantity(variant_id, this.input.value);
          cartUpdateaa.then(cart => {
            updateCartBubbles(cart);
            updateCartProgress(cart)
            updateFreeShippingMessage(cart.total_price / 100);
          })

        }
      }
      this.updateInputQuantity(variant_id, e.target.value);
    })

    // NEWSTUFF
    this.querySelectorAll('button').forEach(
      (button) => {
        button.addEventListener('click', this.onButtonClick.bind(this))
        // button.addEventListener('lockQuantity', this.lockButton.bind(this))
      }
    );

    // }
  }

  handleSingle(single_bundle, variant_id, quantity, addon_id) {
    if (single_bundle) {
      setSingleBundle(variant_id, quantity, addon_id)
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    this.previousValue = this.input.value * 1;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
  updateQuantity(id, quantity) {
    const bodys = {
      updates: {
        [id]: quantity
      }
    }
    return fetch('/cart/update.js', {
      method: "POST",

      credentials: 'same-origin',
      cache: 'no-store',

      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(bodys)
    })
      .then((res) => res.json())
      .then((res) => res);
  }
  updateQuantityMultiple(update) {
    const body = {
      updates: update
    }
    return fetch('/cart/update.js', {
      method: "POST",

      credentials: 'same-origin',
      cache: 'no-store',

      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(body)
    })
      .then((res) => res.json())
      .then((res) => res);
  }

  handleMinusButton() {
    if (this.input && this.input.value == 0) {
      this.minusButton.disabled = true;
    } else {
      if (this.minusButton)
        this.minusButton.disabled = false;
    }
  }

  /*
    Updates the quantity in the Quantity Input component to reflect the new quantity.
  */
  updateInputQuantity(variant_id, quantity) {
    const QuantityInputs = document.querySelectorAll(`quantity-input[data-id='${variant_id}']`);
    QuantityInputs.forEach(quantityInput => {
      quantityInput.input.value = quantity;
      quantityInput.handleMinusButton();
    })
  }

  getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    })
      .then((res) => res.json())
      .then((res) => res);
  }
}

customElements.define('quantity-input', QuantityInput);


class AddOnCheck extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input')

    this.input.addEventListener("change", (e) => {

      const variant_id = e.target.dataset.variant;
      var quantity = e.target.dataset.quantity;
      if (!((window.customer || {}).tags || "").includes('Appstle_Subscriber')) {
        const QuantityInputs = document.querySelectorAll(`quantity-input[data-id='${e.target.dataset.id}']`)[0];
        var cartUpdate = {};

        if (e.target.checked) {
          this.checkedInput(quantity, QuantityInputs, e, variant_id)
        } else {
          this.unCheckedInput(variant_id, QuantityInputs, quantity, e.target.dataset.id, e)
        }
      }
      this.handleAllChecked(e.target.checked, e.target.dataset.id)
    })

  }

  handleAllChecked(checked, variant_id) {
    const QuantityInputs = document.querySelectorAll(`addon-overlay input[data-id='${variant_id}']`);
    QuantityInputs.forEach(quantityInput => {
      quantityInput.checked = checked;
    })

  }

  updateInputQuantity(variant_id, quantity) {
    const QuantityInputs = document.querySelectorAll(`quantity-input[data-id='${variant_id}']`);
    QuantityInputs.forEach(quantityInput => {
      quantityInput.input.value = quantity;
      quantityInput.handleMinusButton();
    })
  }

  checkedInput(quantity, QuantityInputs, e, variant_id) {
    if (QuantityInputs.input.value > 0) {
      quantity = (QuantityInputs.input.value) * quantity;
    }
    else {
      quantity = (1) * quantity;
    }
    var previous_quantity = 0
    var i_q = 0
    this.getCart().then(res => {
      res.items.forEach(item => {
        if (item.id == variant_id) {
          previous_quantity += item.quantity;
        }
        if (item.id == e.target.dataset.id) {
          i_q = item.quantity;
        }
      });
      quantity += previous_quantity;
      if (QuantityInputs.input.value <= 0) {
        var p = 1
        if (e.target.dataset.single_bundle) {
          p = 0;
        }
        this.updateQuantity(
          {
            [variant_id]: quantity,
            [e.target.dataset.id]: p
          }).then(res => {
            updateCartBubbles(res);
            updateCartProgress(res)
            updateFreeShippingMessage(res.total_price / 100);
            this.updateInputQuantity(e.target.dataset.id, 1)
            setAddOns(e.target.dataset.id, res.token)
            this.handleSingle(e, quantity, variant_id);
          })
      } else {
        if (e.target.dataset.single_bundle) {
          i_q = 0;
        }
        this.updateQuantity({
          [variant_id]: quantity,
          [e.target.dataset.id]: i_q
        }).then(res => {
          updateCartBubbles(res);
          updateCartProgress(res)
          updateFreeShippingMessage(res.total_price / 100);
          setAddOns(e.target.dataset.id, res.token)
          this.handleSingle(e, quantity, variant_id)
        })
      }
    });
  }


  unCheckedInput(variant_id, QuantityInputs, quantity, v_id, e) {
    var previous_quantity = 0
    this.getCart().then(res => {
      res.items.forEach(item => {
        if (item.id == variant_id) {
          previous_quantity += item.quantity;
        }
      });
      quantity = previous_quantity - QuantityInputs.input.value * quantity;
      if (quantity < 0)
        quantity = 0;
      // if(e.target.dataset.single_bundle){
      //   quantity = quantity/e.target.dataset.quantity;
      // }
      this.updateQuantity({
        [variant_id]: quantity,
        [v_id]: QuantityInputs.input.value
      }).then(res => {
        updateCartBubbles(res);
        updateCartProgress(res);
        updateFreeShippingMessage(res.total_price / 100);
        removeVariantId(v_id)
        this.handleSingle(e, 0, variant_id)
      })
    })
  }

  handleSingle(e, quantity, addon_id) {
    if (e.target.dataset.single_bundle) {
      setSingleBundle(e.target.dataset.id, (quantity / e.target.dataset.quantity), addon_id)
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }


  updateQuantity(updates) {
    const body = {
      updates: updates
    }
    return fetch('/cart/update.js', {
      method: "POST",

      credentials: 'same-origin',
      cache: 'no-store',

      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(body)
    })
      .then((res) => res.json())
      .then((res) => res);
  }

  getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    })
      .then((res) => res.json())
      .then((res) => res);
  }

}

customElements.define('addon-overlay', AddOnCheck);



function setAddOns(variant_id, token) {
  var aad = localStorage.getItem('addons')
  if (aad) {
    try {
      aad = JSON.parse(localStorage.getItem('addons'))
      aad['key'] = token;
      aad['variant_ids'].push(variant_id);
      localStorage.setItem('addons', JSON.stringify(aad))
      return
    }
    catch (error) {
    }
  }
  localStorage.setItem('addons', JSON.stringify({ 'key': token, 'variant_ids': [variant_id] }))
}

function setSingleBundle(variant_id, quantity, addon_id) {
  addon_id = addon_id.toString()
  variant_id = variant_id.toString()
  var aad = localStorage.getItem('single_bundle')
  if (aad) {
    try {
      aad = JSON.parse(localStorage.getItem('single_bundle'))
      if (aad[addon_id]) {
        aad[addon_id][variant_id] = quantity;
      }
      else {
        aad[addon_id] = {};
        aad[addon_id][variant_id] = quantity
      }
      localStorage.setItem('single_bundle', JSON.stringify(aad))
      return
    }
    catch (error) {
    }
  }
  var x = {}
  x[addon_id] = {};
  x[addon_id][variant_id] = quantity
  localStorage.setItem('single_bundle', JSON.stringify(x))
}


function removeVariantId(variant_id) {

  var aad = localStorage.getItem('addons')
  if (aad) {
    try {
      aad = JSON.parse(localStorage.getItem('addons'))
      var filteredArray = aad['variant_ids'].filter(function (e) { return e !== variant_id.toString() })
      aad['variant_ids'] = filteredArray

      localStorage.setItem('addons', JSON.stringify(aad))
      return
    }
    catch (error) {
    }
  }


}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

const formToObject = form => {
  const obj = {}
  const formData = new FormData(form)
  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }
  return obj
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` },
    credentials: 'same-origin',
    cache: 'no-store'

  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if (this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => { parent.querySelector('li.product__media-item').scrollIntoView({ behavior: "smooth" }); });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

function cartHandler(arg) {
}
function mapLineItmes(items) {
  return items.map(item => ({
    id: item.id,
    variantId: item.variant_id,
    price: item.final_price / 100,
    quantity: item.quantity,
    image: item.image,
    title: item.title
  }))
}
function updateCartBubbles(cart) {
  const cartCounts = document.querySelectorAll(".cart-count-bubble [aria-hidden]");
  for (const cartCount of cartCounts) {
    cartCount.innerText = cart.item_count;
  }
  var drawerTemplate = document.getElementById('drawerOverlayTemplate');
  drawerTemplate = drawerTemplate.cloneNode(true);
  var drawer = drawerTemplate.content.querySelector('.drawer-overlay');
  var drawerItemTemplate = document.getElementById('drawerItemTemplate');
  var templateDrawerItem = drawerItemTemplate.content.querySelector(".item");
  var itemsContainer = drawer.querySelector(".items-container");
  var lineItems = mapLineItmes(cart.items);
  var items_subtotal_price = cart.total_price / 100;
  var subtotalPrice = drawer.querySelector(".subtotal .price");
  const shippingPrice = drawer.querySelector(".shipping .price");
  const grandPrice = drawer.querySelector(".grandtotal .price");
  var drawerMessage = drawer.querySelector(".message");
  var orderDates = drawer.querySelector(".order-dates");
  var skipWeek = drawer.querySelector(".skip-week");
  var itemQuantity = drawer.querySelector(".item-quantity");
  var itemManager = {}
  itemQuantity.innerText = cart.item_count;

  subtotalPrice.textContent =
    "$" + parseFloat(items_subtotal_price).toFixed(2);

  var shippingTotal = 6.95;
  if(items_subtotal_price>=65){
    shippingTotal = "Free"
  }
  
    
  shippingPrice.textContent = "$" + shippingTotal;
  var totalPrice = items_subtotal_price
  if(shippingPrice != "Free"){
    totalPrice = (items_subtotal_price + shippingTotal)
  }
  grandPrice.innerText = "$" + parseFloat(totalPrice).toFixed(2);

  if (lineItems.length == 0) {
    drawerMessage.textContent = "YOUR CART IS EMPTY";
  } else {
    const awayFromFreeDelevery = (65 - items_subtotal_price);

    if (awayFromFreeDelevery > 0) {
      const formatedPrice = "$" + parseFloat(awayFromFreeDelevery).toFixed(2);
      drawerMessage.innerHTML = `ONLY <span class="red-price">${formatedPrice}</span> AWAY FROM FREE DELIVERY`;
    } else {
      drawerMessage.innerHTML = "";
    }
  }

  itemsContainer.innerHTML = "";
  renderItems(lineItems, itemsContainer, templateDrawerItem);
  if (itemManager.customerId) {
    const arrivingDate = orderDates.querySelector(".arriving-date");
    const changable = orderDates.querySelector(".changeable");
    const { nextBillingDate } = itemManager.subscriptionCache.data;
    const billingDate = new Intl.DateTimeFormat("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
    }).format(new Date(nextBillingDate));

    //insert the actual date
    const changableUntilDate = new Date(nextBillingDate);
    changableUntilDate.setDate(changableUntilDate.getDate()); //Charge Date

    const arriveDateActual = new Date(nextBillingDate);
    arriveDateActual.setDate(arriveDateActual.getDate() + 4);


    const arriveDateActualDay = new Intl.DateTimeFormat("en", {
      weekday: "long",
      month: "long",
      day: "numeric",
    }).format(arriveDateActual);
    arrivingDate.innerText = arriveDateActualDay;

    const changableUntilWeekday = new Intl.DateTimeFormat("en", {
      weekday: "long",
    }).format(changableUntilDate); //get weekday
    const changableUntilTime = new Intl.DateTimeFormat("en", {
      hour: "numeric",
      minute: "numeric",
    }).format(changableUntilDate); //get hour and mintue

    changable.innerHTML = `Changable until ${changableUntilWeekday} at ${changableUntilTime}`;
    const bannerOrderDates = document.querySelector(
      ".subscription-banner .order-dates"
    );

    bannerOrderDates.replaceWith(orderDates.cloneNode(true));

    orderDates.style.display = "block";
    skipWeek.style.display = "block";
  } else {
    orderDates.style.display = "none";
    skipWeek.style.display = "none";
  }
  if (drawer.querySelector(".loader"))
    drawer.querySelector(".loader").style.display = "none";
  document.getElementById("popupDrawer").innerHTML = drawer.querySelector(".popup-drawer").innerHTML
  document.querySelector(".drawer__close-button").addEventListener("click", closeDrawer)
}
var free_gift_id = "40483132735530";
var free_gift_handle_name = "organika-keto-mini-cookies"
//commented out the remove free gift code so there is no get error on the menu page when zeroing out a product
async function updateCartProgress(data) {
  if (((data || {}).items || []).length == 1 && data.items[0].id == free_gift_id) {
    //removeFreeGift()
  }
  else if (((data || {}).items || []).length > 0) {
    if (data.items.filter(item => item.id == free_gift_id).length == 0)
      addFreeGift();
    else if(!free_gift_is_active){
      //removeFreeGift()
    }
  }
  else
    //removeFreeGift()
  if (document.getElementById("collection_progress_overlay")) {
    var dela = ms => new Promise(res => setTimeout(res, ms));

    try {
      var free_delivery = 6500;
      var minimum_order = 4000;
      var free_gift = 8500;
      var has_selling_plan_allocation = false;
      var items = ((data || {}).items || [])
      items.forEach(item => {
        if (Object.keys(item.selling_plan_allocation || {}).length > 0) {
          has_selling_plan_allocation = true;
        }
      })
      if (has_selling_plan_allocation) {
        free_delivery = 6100;
        minimum_order = 3800;
      }
      if (data.total_price < free_gift) {
        removeFreeGift()
      }

      if (data.total_price >= free_gift) {
        update_rewards_overlay_milestone(100, "minimum-order")
        await dela(210)
        add_circle_progress("free-delivery")
        update_rewards_overlay_milestone(100, "free-delivery")
        await dela(210)
        add_circle_progress("free-gift")
        update_rewards_overlay_milestone(100, "free-gift")
        await dela(210)
        add_circle_progress("end")
        await addFreeGift()
        update_message_overlay(`Hooray! You unlocked free gift 🎉`)

      }
      else if (data.total_price >= free_delivery) {
        remove_circle_progress("end")
        update_rewards_overlay_milestone(100, "minimum-order")
        await dela(210)
        add_circle_progress("free-delivery")
        update_rewards_overlay_milestone(100, "free-delivery")
        await dela(210)
        add_circle_progress("free-gift")
        update_rewards_overlay_milestone(0, "free-gift")

        update_rewards_overlay_milestone((data.total_price / free_gift) * 100, "free-gift")
        var x = ((free_gift - data.total_price) / 100).toFixed(2)
        update_message_overlay(`Add $${x} to your cart to unlock free gift.`)


      } else if (data.total_price >= minimum_order) {
        remove_circle_progress("end")
        update_rewards_overlay_milestone(0, "free-gift")
        await dela(210)
        remove_circle_progress("free-gift")
        update_rewards_overlay_milestone(100, "minimum-order")
        await dela(210)
        add_circle_progress("free-delivery")
        update_rewards_overlay_milestone((data.total_price / free_delivery) * 100, "free-delivery")
        var x = ((free_delivery - data.total_price) / 100).toFixed(2)
        update_message_overlay(`Add $${x} to your cart to unlock free delivery.`)
      } else {
        remove_circle_progress("end")
        update_rewards_overlay_milestone(0, "free-gift")
        await dela(210)
        remove_circle_progress("free-gift")
        update_rewards_overlay_milestone(0, "free-delivery")
        await dela(210)
        remove_circle_progress("free-delivery")
        update_rewards_overlay_milestone((data.total_price / minimum_order) * 100, "minimum-order")
        var x = ((minimum_order - data.total_price) / 100).toFixed(2)
        update_message_overlay(`Add $${x} to your cart to meet the minimum order amount.`)
      }
    } catch (err) {
      console.log(err)
    }

  }
}
var free_gift_is_active = false;

async function check_free_gift(){
  var free_gift_check = await fetch(`/products/${free_gift_handle_name}.js`)
  if(free_gift_check.status==200){
    free_gift_is_active = true;
  }  
}
//check_free_gift() //removed as this is returning a 404 error from Shopify

async function addFreeGift() {
  if (free_gift_is_active) {
    var data = { "items": [{ "id": free_gift_id, "quantity": 1 }] }
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    })
    await res.json()
    res = await fetch("/cart.js")
    var r = await res.json();
    updateCartBubbles(r)
  }
  else{
    //removeFreeGift(); //removed for call to update that comes back no product avaliable
  }
}

async function removeFreeGift() {
  var data = { "updates": {} }
  data['updates'][free_gift_id] = 0
  var res = await fetch('/cart/update.js', {
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  })
  var r = await res.json()
  //updateCartBubbles(r) //duplicate call causing cart to have undefined

}
function update_rewards_overlay_milestone(percentage, order) {
  var progress_overlay = document.getElementById("collection_progress_overlay")
  progress_overlay.querySelector(`.reward-progress-background-bar.${order}`).style = `width:${percentage}%`;

}
function update_message_overlay(message) {
  var progress_overlay = document.getElementById("collection_progress_overlay")
  progress_overlay.querySelector(`.reward-progress-message`).innerHTML = `${message}`;
}
function add_circle_progress(selector) {
  var progress_overlay = document.getElementById("collection_progress_overlay")
  progress_overlay.querySelector(`.progress-circle.${selector}`).classList.add('green')

}
function remove_circle_progress(selector) {
  var progress_overlay = document.getElementById("collection_progress_overlay")
  progress_overlay.querySelector(`.progress-circle.${selector}`).classList.remove('green')
}


function removeLockedMilestone(selector) {
  var progress_overlay = document.getElementById("collection_progress_overlay")
  progress_overlay.querySelector(`.${selector} .reward-icon`).classList.remove('d-none')
  progress_overlay.querySelector(`.${selector} .reward-icon-lock`).classList.add('d-none')
}
function addLockedMilestone(selector) {
  var progress_overlay = document.getElementById("collection_progress_overlay")
  progress_overlay.querySelector(`.${selector} .reward-icon`).classList.add('d-none')
  progress_overlay.querySelector(`.${selector} .reward-icon-lock`).classList.remove('d-none')
}

function closeDrawer() {
  var drawerPopup = document.querySelector("#popupDrawer");
  var drawer = ""
  drawerPopup.classList.add("closing-drawer");
  setTimeout(() => {
    drawerPopup.classList.remove("closing-drawer");
    drawerPopup.style.display = "none";
    if (!drawer) {
      drawer = document.querySelector(".drawer-overlay")
    }
    drawer.style.display = "none";
  }, 500);
};
function renderItems(lineItems, drawerItems, templateDrawerItem) {
  lineItems.forEach((lineItem) => {
    const { id, image, price, title, quantity, variantId } = lineItem;
    const item = templateDrawerItem.cloneNode(true);
    const productImage = item.querySelector("img");
    const productTitle = item.querySelector(".title");
    const productQuantity = item.querySelector(".quantity__input");
    const productPrice = item.querySelector(".price");

    productImage.src = image;
    productTitle.innerText = title;
    productQuantity.setAttribute('value', quantity);
    productQuantity.dataset.id = variantId;
    productQuantity.dataset.price = price * 100; //price was divided by 100
    productPrice.innerText = "$" + (price * quantity).toFixed(2);
    if (price == 0) {
      item.querySelector("quantity-input").innerHTML = "";
      item.querySelector("quantity-input").style = "border:none;";
    }
    drawerItems.appendChild(item);
  });
}

//synchronize height on product card
//commented out as depricated from changes to css files
//document.addEventListener("readystatechange", (e) => {
//setEqualHeightToProduct();
//setTimeout(setEqualHeightToProduct, 2000);
//})

function setEqualHeightToProduct() {
  let itemPerRow;
  if (window.innerWidth < 990 && window.innerWidth >= 750) {
    itemPerRow = 3;
  } else if (window.innerWidth < 750) {
    itemPerRow = 2;
  } else {
    itemPerRow = 4;
  }

  const collection =
    document.querySelector("#main-collection-product-grid") ||
    document.querySelector("#product-grid");
  const productsCount = collection.childElementCount;
  const rowCount = Math.ceil(productsCount / itemPerRow);

  for (let rowIndex = 0; rowIndex < rowCount; rowIndex++) {
    const row = [];
    for (let productIndex = 1; productIndex <= itemPerRow; productIndex++) {
      const product = collection.querySelector(
        `.grid__item:nth-child(${(rowIndex * itemPerRow) + productIndex})`
      );
      if (product) row.push(product)
    }

    //set equal title height
    const productTitles = row.map(card => card.querySelector(".card-information__text.h2"));
    const productTitleHeights = productTitles.map(wrapper => wrapper.offsetHeight);
    const maxProductTitleHeight = Math.max(...productTitleHeights);
    productTitles.forEach(wrapper => wrapper.style.height = maxProductTitleHeight + "px");

    //set equal price wrapper height
    const priceWrappers = row.map(card => card.querySelector(".price-vendor-wrapper"));
    const priceWrapperHeights = priceWrappers.map(wrapper => wrapper.offsetHeight);
    const maxPriceWrapperHeight = Math.max(...priceWrapperHeights);
    priceWrappers.forEach(wrapper => wrapper.style.height = maxPriceWrapperHeight + "px");
  }
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
}

function loadHeaderSizes() {
  shippingBarSticky = document.querySelector('.shipping-bar-container-inner');
  announcementBar = document.querySelector('.announcement-bar');
  header = document.querySelector('.header-wrapper');
  threshold = announcementBar.offsetHeight + header.offsetHeight;
}

function checkDiscount() {
  var discount_code = getCookie("discount_code");
  if (discount_code != null) {
    showDiscountMessage();
  }
}

function showDiscountMessage() {
  const discountMessage = document.querySelector('.discount-message');
  if(discountMessage) {
    discountMessage.classList.add('is-visible');
  }
}

function setupListeners() {
  const collectionBoxes = document.querySelectorAll('[data-shg-href]');
  collectionBoxes.forEach((collectionBox) => {
    collectionBox.addEventListener('click', () => {
      const link = collectionBox.querySelector('a');
      if(link) {
        link.click();
      }
    });
  });
}

let lastScrollTop = 0;

let shippingBarSticky, announcementBar, header, threshold;

document.addEventListener('DOMContentLoaded', () => {
  loadHeaderSizes();
  checkDiscount();
  setupListeners();
});

window.addEventListener('resize', loadHeaderSizes);

document.addEventListener('scroll', (event) => {
  if(!shippingBarSticky) return;

  if (lastScrollTop > window.scrollY) {
    shippingBarSticky.classList.add('shipping-bar-container-inner--fixed-with-header');
  }
  else {
    shippingBarSticky.classList.remove('shipping-bar-container-inner--fixed-with-header');
  }
  
  if (window.scrollY >= threshold) {
    shippingBarSticky.classList.add('shipping-bar-container-inner--fixed');
  }
  else {
    shippingBarSticky.classList.remove('shipping-bar-container-inner--fixed');
    shippingBarSticky.classList.remove('shipping-bar-container-inner--fixed-with-header');
  }
  
  lastScrollTop = window.scrollY;
});